import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

export const useVehicleAllocationTable = (
  { startDate, endDate, plant, destination, transporterId, role, skip = 0, limit = 50 },
  enabled = true
) => {
  return useQuery({
    queryKey: [
      "vehicleAllocationTable",
      startDate,
      endDate,
      plant,
      destination,
      transporterId,
      role,
      skip,
      limit,
    ],
    queryFn: async () => {
      const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
      if (plant && plant !== "All") params.append("plant", plant);
      if (destination && destination !== "All") params.append("destination", destination);
      if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
      if (role) params.append("role", role);
      params.append("skip", skip);
      params.append("limit", limit);
      const { data } = await Axios.get(
        `${Urls.tmsDashboardVehicleAllocationTable}?${params.toString()}`
      );
      return data;
    },
    enabled,
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
    refetchInterval: enabled ? 5 * 60 * 1000 : false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  });
};
